import axios from "axios";

export default {
  namespaced: true,
  state: {
    lista: [],
    perPage: 100,
    produtoId: null,
    dt1: null,
    dt2: null,
    centroEstoqueId: null,
    registroSelecionadoId: null,
    paginaAtual: 1,
    recarregarLista: false
  },
  getters: {
    LISTA: state => state.lista,
    PER_PAGE: state => state.perPage,
    PRODUTOID: state => state.produtoId,
    DT1: state => state.dt1,
    DT2: state => state.dt2,
    CENTROESTOQUEID: state => state.centroEstoqueId,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
    PAGINA_ATUAL: state => state.paginaAtual,
    RECARREGAR_LISTA: state => state.recarregarLista
  },
  mutations: {
    SET_LISTA: (state, payload) => {
      state.lista = payload
    },
    SET_PER_PAGE: (state, payload) => {
      state.perPage = payload
    },
    SET_PRODUTOID: (state, payload) => {
      state.produtoId = payload
    },
    SET_DT1: (state, payload) => {
      state.dt1 = payload
    },
    SET_DT2: (state, payload) => {
      state.dt2 = payload
    },
    SET_CENTROESTOQUEID: (state, payload) => {
      state.centroEstoqueId = payload
    },
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
      state.registroSelecionadoId = payload
    },
    SET_PAGINA_ATUAL: (state, payload) => {
      state.paginaAtual = payload
    },
    SET_LIMPAR: (state) => {
      state.produtoId = null
      state.centroEstoqueId = null
      state.paginaAtual = 1
      
      // Define datas padrão ao limpar filtros
      const hoje = new Date()
      const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
      state.dt1 = primeiroDiaMes.toISOString().split('T')[0]
      state.dt2 = hoje.toISOString().split('T')[0]
    },
    SET_RECARREGAR_LISTA: (state, payload) => {
      state.recarregarLista = payload
    }
  },
  actions: {
    GET_LISTA: async (context) => {
      try {
        const params = {
          dt1: context.state.dt1,
          dt2: context.state.dt2,
          produtoId: context.state.produtoId,
          centroEstoqueId: context.state.centroEstoqueId
        }
        const { data } = await axios.get(`/api/protected/estoque/ajuste/pesquisar`, { params })
        context.commit('SET_LISTA', data)
        return data
      } catch (error) {
        console.error('Erro ao buscar lista de Ajuste de Estoque', error)
        throw error
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/ajuste-estoque-store.js